import {
  DefaultTemplate,
  Prisma,
  prisma,
  ResourceType,
  ActionType,
  TemplateLevel,
  TemplateFor,
  WhiteLabel,
  AttachmentType,
  NotificationTemplateType,
  TemplateType,
  EventTranslations,
  Language,
  FormEntityType,
} from "client";
import { AnyAaaaRecord } from "dns";

// CREATE
export const createDefaultTemplate = async (
  userId: string,
  data: Prisma.DefaultTemplateCreateInput
) => {
  try {
    console.log("data", data);
    const defaultTemplate = await prisma.defaultTemplate.create({
      data,
    });

    return { defaultTemplate };
  } catch (error) {
    console.log("error", error);
    return { error };
  }
};

// READ
export const getAllDefaultTemplates = async (
  userId: string,
  whiteLabelId?: string,
  organizationId?: string,
  eventId?: string,
  templateFor?: TemplateFor
) => {
  try {
    const whereClause: Prisma.DefaultTemplateWhereInput = {};
    if (whiteLabelId) {
      whereClause.whiteLabelId = whiteLabelId;
    } else if (organizationId) {
      whereClause.organizationId = organizationId;
    } else if (eventId) {
      whereClause.eventId = eventId;
    } else {
      whereClause.level = TemplateLevel.PLATFORM;
    }
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: {
        ...whereClause,
        isActive: true,
        templateFor: {
          in: templateFor
            ? [templateFor]
            : [
                TemplateFor.DIGITAL_TICKET,
                TemplateFor.PRINTABLE_TICKET,
                TemplateFor.DIGITAL_BADGE,
                TemplateFor.PRINTABLE_BADGE,
                TemplateFor.CUSTOM,
              ],
        },
      },
    });
    return defaultTemplates;
  } catch (error) {
    return { error };
  }
};

export const getAllDefaultTemplateForNotification = async (
  id: string
): Promise<{
  template?: DefaultTemplate & {
    email?: any;
    sms?: any;
    whatsapp?: any;
    event?: Event & {
      translations: EventTranslations &
        {
          language: Language;
        }[];
      organizations?: { id: string }[];
    };
    whiteLabel?: WhiteLabel;
    attachments?: {
      design: DefaultTemplate;
      type: AttachmentType;
      repeatForEachTOrderItem?: boolean;
    }[];
  };
  error?: any;
}> => {
  try {
    const digitalBadgeEvents = [
      "Exhibitions",
      "Conferences",
      "Seminars",
      "Workshops",
      "Meetings",
      "Product Launches",
      "Trade Shows",
      "Networking",
    ];
    const template = await prisma.defaultTemplate.findUnique({
      where: { id },
      include: {
        event: {
          include: {
            translations: {
              include: {
                language: true,
              },
            },
            whiteLabel: true,
            category: {
              include: {
                translations: {
                  where: {
                    language: {
                      code: "en",
                    },
                  },
                },
              },
            },
          },
        },
        whiteLabel: true,
        defaultTemplateAttachments: {
          include: {
            defaultTemplateAttachment: true,
          },
        },
      },
    });
    const getNotificationType = (type: string) => {
      if (type === "EMAIL") return NotificationTemplateType.EMAIL_DESIGN;
      if (type === "SMS") return NotificationTemplateType.SMS;
      return NotificationTemplateType.WHATSAPP;
    };
    console.log("template", template);
    return {
      template: {
        ...template,
        email: {
          htmlTemplate: (template?.data as any)?.html || "",
          subject: template?.subject,
        },
        type: getNotificationType(template?.type || ""),
        whiteLabel: template?.whiteLabel || template?.event?.whiteLabel,
        attachments: template?.defaultTemplateAttachments
          ?.filter((attachment) => attachment.defaultTemplateAttachment)
          // .filter((attachment) => {
          //   if (
          //     digitalBadgeEvents.includes(
          //       template?.event?.category?.translations[0]?.name || ""
          //     )
          //   ) {
          //     return (
          //       attachment.defaultTemplateAttachment?.type ===
          //       TemplateType.BADGE
          //     );
          //   }
          //   return (
          //     attachment.defaultTemplateAttachment?.type === TemplateType.TICKET
          //   );
          // })
          .map((attachment) => ({
            type: attachment.type,
            design: {
              ...attachment.defaultTemplateAttachment,

              translations: [
                {
                  language: "en",
                  json: (attachment.defaultTemplateAttachment?.data as any)
                    ?.json,
                  html: (attachment.defaultTemplateAttachment?.data as any)
                    ?.html,
                },
              ],
            },
            repeatForEachTOrderItem: attachment.repeatForEachTOrderItem,
          })),
      } as any,
    };
  } catch (error) {
    return { error };
  }
};

export const getDefaultTemplateById = async (userId: string, id: string) => {
  try {
    const defaultTemplate = await prisma.defaultTemplate.findUnique({
      where: { id },
    });

    return defaultTemplate;
  } catch (error) {
    return { error };
  }
};

export const getDefaultTemplatesByWhiteLabelId = async (
  userId: string,
  whiteLabelId: string
) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { whiteLabelId, level: TemplateLevel.WHITE_LABEL },
    });

    return defaultTemplates;
  } catch (error) {
    return [];
  }
};

export const getDefaultTemplatesByOrganizationId = async (
  userId: string,
  organizationId: string
) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { organizationId },
    });

    return defaultTemplates;
  } catch (error) {
    return [];
  }
};

export const getPlatformDefaultTemplate = async (userId: string) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { level: TemplateLevel.PLATFORM },
    });

    return defaultTemplates;
  } catch (error) {
    return [];
  }
};

export const getPlatformCreatedDefaultTemplatesTemplateFor = async (
  userId: string
) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { level: TemplateLevel.PLATFORM },
    });

    return defaultTemplates.map((template) => template.templateFor);
  } catch (error) {
    return [];
  }
};
export const getEventDefaultTemplates = async (
  userId: string,
  eventId: string,
  filter: Prisma.DefaultTemplateWhereInput = {}
) => {
  try {
    const whereClause: Prisma.DefaultTemplateWhereInput = {
      ...filter,
    };
    if (eventId) {
      whereClause.eventId = eventId;
    }
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: whereClause,
    });

    return defaultTemplates;
  } catch (error) {
    return [];
  }
};

export const getDefaultTemplateByEventIdAndTemplateFor = async (
  eventId: string,
  templateFor: TemplateFor[]
) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { eventId, templateFor: { in: templateFor }, isActive: true },
    });

    return defaultTemplates;
  } catch (error) {
    return { error };
  }
};
export const getDefaultTemplateByWhiteLabelIdAndTemplateFor = async (
  whiteLabelId: string,
  templateFor: TemplateFor[]
) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { whiteLabelId, templateFor: { in: templateFor }, isActive: true },
    });

    return defaultTemplates;
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateDefaultTemplateById = async (
  userId: string,
  id: string,
  data: Prisma.DefaultTemplateUpdateInput
) => {
  try {
    const defaultTemplate = await prisma.defaultTemplate.update({
      where: { id },
      data: {
        ...data,
      },
    });

    return { defaultTemplate };
  } catch (error) {
    console.log("error", error);
    return { error };
  }
};

export const activateDeActivateDefaultTemplateById = async (
  userId: string,
  id: string
) => {
  try {
    const defaultTemplate = await prisma.defaultTemplate.findUnique({
      where: { id },
    });

    if (!defaultTemplate) {
      throw new Error("Default template not found");
    }

    const updatedDefaultTemplate = await prisma.defaultTemplate.update({
      where: { id },
      data: { isActive: !defaultTemplate.isActive },
    });

    return updatedDefaultTemplate;
  } catch (error) {
    return { error };
  }
};
// DELETE
export const deleteDefaultTemplateById = async (userId: string, id: string) => {
  try {
    const defaultTemplate = await prisma.defaultTemplate.delete({
      where: { id },
    });

    return { defaultTemplate };
  } catch (error) {
    return { error };
  }
};

export const setNewWhiteLabelWithDefaultTemplates = async (
  userId: string,
  whiteLabelId: string
) => {
  try {
    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { level: TemplateLevel.PLATFORM },
      include: {
        defaultTemplateAttachments: true,
      },
    });

    // Create new templates with their attachments
    const createdTemplates = await Promise.all(
      defaultTemplates.map(async (template) => {
        const newTemplate = await prisma.defaultTemplate.create({
          data: {
            data: template.data as Prisma.InputJsonValue,
            level: TemplateLevel.WHITE_LABEL,
            templateFor: template.templateFor,
            type: template.type,
            name: template.name,
            subject: template.subject,
            organizationId: null,
            createdAt: new Date(),
            updatedAt: new Date(),
            whiteLabelId: whiteLabelId,
          },
        });

        // Copy attachments if they exist
        if (
          template.defaultTemplateAttachments &&
          template.defaultTemplateAttachments.length > 0
        ) {
          await prisma.attachment.createMany({
            data: template.defaultTemplateAttachments.map((attachment) => ({
              type: attachment.type,
              defaultTemplateAttachmentId:
                attachment.defaultTemplateAttachmentId,
              defaultTemplateId: newTemplate.id,
              repeatForEachTOrderItem: attachment.repeatForEachTOrderItem,
              name: attachment.name,
              link: attachment.link,
            })),
          });
        }

        return newTemplate;
      })
    );

    return { whitelabelTemplates: createdTemplates };
  } catch (error) {
    return { error };
  }
};

export const setNewOrganizationWithDefaultTemplates = async (
  userId: string,
  organizationId: string
) => {
  try {
    const organization = await prisma.organization.findUnique({
      where: { id: organizationId },
    });

    if (!organization) {
      throw new Error("Organization not found");
    }

    const whitelabelTemplates = await prisma.defaultTemplate.findMany({
      where: {
        whiteLabelId: organization.whiteLabelId,
        level: TemplateLevel.WHITE_LABEL,
      },
      include: {
        defaultTemplateAttachments: true,
      },
    });

    const defaultTemplates = await prisma.defaultTemplate.findMany({
      where: { level: TemplateLevel.PLATFORM },
      include: {
        defaultTemplateAttachments: true,
      },
    });

    let templates = [...whitelabelTemplates];

    defaultTemplates.forEach((template) => {
      const existingTemplate = templates.find(
        (t) => t.templateFor === template.templateFor
      );
      if (!existingTemplate) {
        templates.push(template);
      }
    });

    // Create templates and their attachments
    const createdTemplates = await Promise.all(
      templates.map(async (template) => {
        const newTemplate = await prisma.defaultTemplate.create({
          data: {
            type: template.type,
            data: template.data as Prisma.InputJsonValue,
            level: TemplateLevel.ORGANIZATION,
            templateFor: template.templateFor,
            organizationId: organizationId,
            createdAt: new Date(),
            updatedAt: new Date(),
            whiteLabelId: null,
          },
        });

        // Copy attachments if they exist
        if (
          template.defaultTemplateAttachments &&
          template.defaultTemplateAttachments.length > 0
        ) {
          await prisma.attachment.createMany({
            data: template.defaultTemplateAttachments.map((attachment) => ({
              type: attachment.type,
              defaultTemplateAttachmentId:
                attachment.defaultTemplateAttachmentId,
              defaultTemplateId: newTemplate.id,
              repeatForEachTOrderItem: attachment.repeatForEachTOrderItem,
              name: attachment.name,
              link: attachment.link,
            })),
          });
        }

        return newTemplate;
      })
    );

    return { organizationTemplates: createdTemplates };
  } catch (error) {
    return { error };
  }
};

export const setNewEventWithDefaultTemplates = async (
  userId: string,
  eventId: string
) => {
  try {
    const event = await prisma.event.findUnique({
      where: { id: eventId },
      select: {
        id: true,
        organizationIds: true,
        whiteLabelId: true,
      },
    });

    if (!event) {
      throw new Error("Event not found");
    }

    // Get platform level default templates
    const platformTemplates = await prisma.defaultTemplate.findMany({
      where: {
        level: TemplateLevel.PLATFORM,
        isActive: true,
      },
      include: {
        defaultTemplateAttachments: true,
      },
    });

    // Get organization level default templates if event has organization
    const organizationTemplates = event.organizationIds?.length
      ? await prisma.defaultTemplate.findMany({
          where: {
            level: TemplateLevel.ORGANIZATION,
            organizationId: event.organizationIds[0], // Using first organization ID
            isActive: true,
          },
          include: {
            defaultTemplateAttachments: true,
          },
        })
      : [];

    // Get white label level default templates if event has white label
    const whiteLabelTemplates = event.whiteLabelId
      ? await prisma.defaultTemplate.findMany({
          where: {
            level: TemplateLevel.WHITE_LABEL,
            whiteLabelId: event.whiteLabelId,
            isActive: true,
          },
          include: {
            defaultTemplateAttachments: true,
          },
        })
      : [];

    // Combine all templates
    const templates = [...organizationTemplates];

    whiteLabelTemplates.forEach((template) => {
      const existingTemplate = templates.find(
        (t) => t.templateFor === template.templateFor
      );
      if (!existingTemplate) {
        templates.push(template);
      }
    });

    platformTemplates.forEach((template) => {
      const existingTemplate = templates.find(
        (t) => t.templateFor === template.templateFor
      );
      if (!existingTemplate) {
        templates.push(template);
      }
    });

    // Create event level templates with their attachments
    const createdTemplates = await Promise.all(
      templates.map(async (template) => {
        const newTemplate = await prisma.defaultTemplate.create({
          data: {
            name: template.name,
            type: template.type,
            subject: template.subject,
            data: template.data,
            level: TemplateLevel.EVENT,
            templateFor: template.templateFor,
            eventId: eventId,
            organizationId: event.organizationIds?.[0] || null,
            whiteLabelId: event.whiteLabelId || null,
            isActive: true,
          },
        });

        // Copy attachments if they exist
        if (
          template.defaultTemplateAttachments &&
          template.defaultTemplateAttachments.length > 0
        ) {
          console.log("template.attachments", newTemplate.id);
          await prisma.attachment.createMany({
            data: template.defaultTemplateAttachments.map((attachment) => ({
              type: attachment.type,
              defaultTemplateAttachmentId:
                attachment.defaultTemplateAttachmentId,
              defaultTemplateId: newTemplate.id,
              repeatForEachTOrderItem: attachment.repeatForEachTOrderItem,
              name: attachment.name,
              link: attachment.link,
            })),
          });
        }

        return newTemplate;
      })
    );

    // Create default Order Form for the event
    const languages = await prisma.language.findMany();
    const enLang = languages.find((l) => l.code === "en");
    const arLang = languages.find((l) => l.code === "ar");

    const defaultOrderFormJson = {
      pages: [
        {
          elements: [
            {
              type: "text",
              name: "name",
              title: { en: "Name", ar: "الاسم" },
              isRequired: true,
            },
            {
              type: "text",
              name: "email",
              title: { en: "Email", ar: "البريد الإلكتروني" },
              inputType: "email",
              isRequired: true,
              validators: [{ type: "email" }],
            },
            {
              type: "phone-number",
              name: "phone",
              title: { en: "Phone Number", ar: "رقم الهاتف" },
              isRequired: true,
            },
          ],
        },
      ],
    };

    if (event.whiteLabelId) {
      await prisma.formTemplate.create({
        data: {
          whiteLabelId: event.whiteLabelId,
          eventId: eventId,
          json: defaultOrderFormJson,
          numberOfQuestions: 3,
          text: JSON.stringify(defaultOrderFormJson),
          formEntities: {
            create: {
              type: FormEntityType.EVENT,
              entityID: eventId,
            },
          },
          translations: {
            createMany: {
              data: [
                ...(enLang
                  ? [{ name: "Registration Form", languageId: enLang.id }]
                  : []),
                ...(arLang
                  ? [{ name: "نموذج التسجيل", languageId: arLang.id }]
                  : []),
              ],
            },
          },
        },
      });
    }

    return {
      templates: createdTemplates,
    };
  } catch (error) {
    console.error("Error in setNewEventWithDefaultTemplates:", error);
    return {
      error:
        error instanceof Error
          ? error.message
          : "Failed to set default templates",
    };
  }
};
